import React, { useContext } from "react";
import Heading from "../../../../shared/Heading/Heading";
import DayUseConfirmationScreenCard from "../SectionComponents/DayUseConfirmationScreenCard";
import Button from "../../../../shared/Button/Button";
import LoadingContainer from "../../../../shared/LoadingContainer/LoadingContainer";
import { DayUseContext } from "../../../../context/DayUseContext";
import BLParagraph from "../../../../shared/Ionic/Paragraph/BLParagraph";

const ConfirmationScreenView = () => {
  const {
    refreshSearchParams,
    isProcessingDayUseBookings,
    processedRecordsResults,
    history,
    dayUseCCDetails,
    dayUseOccasions,
    dayUseTexts
  } = useContext(DayUseContext);

  return (
    <>
      {isProcessingDayUseBookings ? (
        <LoadingContainer />
      ) : (
        <>
          <Heading
            txt={"Confirmation"}
            new_styles={{
              paddingBottom: "24px",
              textAlign: "center",
              font: "normal normal bold 26px/28px Crimson Pro",
              color: "#545E88",
            }}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p style={{ textAlign: "center" }}>{`Please find your ${
              processedRecordsResults.length === 1
                ? "reservation"
                : "reservations"
            } summary below`}</p>
          </div>

          {processedRecordsResults.map((row, index) => (
            <DayUseConfirmationScreenCard
              key={row.bookingId}
              row={row}
              index={index}
              source={"confScreen"}
              dayUseCCDetails={dayUseCCDetails}
              dayUseOccasions={dayUseOccasions}
            />
          ))}

          {processedRecordsResults.filter((row) => row.status !== "Failed")
            .length > 0 && (
            <div
              style={{
                display: "flex",
                paddingTop: "16px",
                paddingBottom: "16px",
              }}
            >
              <BLParagraph
                txt={dayUseTexts?.Paragraph_EmailConfirmationText}
                newStyles={{
                  font: "normal normal bold 18px/24px Open Sans",
                  color: "#545E88",
                  textAlign: "center",
                }}
                markDown
              />
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
              marginTop: "20px",
            }}
          >
            <p
              style={{
                color: "#699DB0",
                font: "normal normal 600 18px/22px Open Sans",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => history.push("/")}
            >
              {"Close"}
            </p>

            <Button
              txt={"Add another experience"}
              onClick={() => refreshSearchParams("show-activities", true)}
              backgroundColor={"#699DB0"}
              newStyles={{ border: "none", marginLeft: "15px" }}
              minHeight={55}
              height={55}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ConfirmationScreenView;
